import { FC } from 'react'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import { MultiSelect, Button, Form, Textarea } from 'components/Forms'
import BaseModal from 'components/Modals/BaseModal'
import { Alert } from 'ui'
import { closeModal } from 'store/actions/modals'
import PunchService from 'services/PunchService'

import { t } from 'translations'

type Props = {
  punchCard: MData.PunchCard
  projectOptions: { value: string; label: string }[]
}

const PunchProjectTransferModal: FC<Props> = ({ punchCard, projectOptions }) => {
  const dispatch = useDispatch()
  const { userInfo } = useSelector((state: MStore.RootState) => state.users)

  return (
    <BaseModal hideButtons title={`employee.punch.TRANSFER_PROJECT_MODAL`}>
      <Alert variant="warning" className="mt-2">
        {t(`employee.punch.TRANSFERPROJECTCOMMENT`)}
      </Alert>
      <Formik
        enableReinitialize={true}
        initialValues={{ projectId: projectOptions[0]?.value, comment: '' }}
        onSubmit={values => {
          PunchService.transferProject(punchCard._id, values.projectId, userInfo, values.comment)
          // Close the modal
          dispatch(closeModal())
        }}
      >
        {({ values, status, isSubmitting, setStatus }) => {
          return (
            <Form className="mt-2">
              {/* Error message */}
              <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                {status?.msg}
              </Alert>
              <MultiSelect module="employee.punch" name="projectId" options={projectOptions} />
              <div>
                <Textarea className="mt-3" module="employee.punch" name="comment" />
              </div>
              <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} disabled={!values.projectId} text="SUBMIT" />
              <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
                {t(`actions.CLOSE`)}
              </Button>
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default PunchProjectTransferModal
